import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class StrictEmailValidator {
  // Basic strict regex: enforces domain + TLD with 2+ characters
  private static readonly strictEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  static strictEmail(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      // Allow empty field (let Required validator handle that)
      if (!value) return null;

      const isValid = StrictEmailValidator.strictEmailRegex.test(value);
      return isValid ? null : { strictEmail: true };
    };
  }
}
